import { render, staticRenderFns } from "./AppBarUserMenu.vue?vue&type=template&id=696865fa"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=js"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=js"
import style0 from "./AppBarUserMenu.vue?vue&type=style&index=0&id=696865fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports